import styled from "styled-components";

interface ScrollableListProps {
  scrollable: boolean;
}

export const FullHeightWrapper = styled.div`
  height: 720px;
  margin: 10px 0px 70px 0px;
`;

export const GridWrapper = styled.div`
  display: grid;
 grid-template-columns: 1fr 300px;
  gap: 2px;
  height: 720px;
  padding-bottom: 25px;
`;

export const LeftContainer = styled.div`
`;

export const RightContainer = styled.div`
  height: 720px;
  position: relative;
  overflow: visible;
`;

export const ScrollableList = styled.div<ScrollableListProps>`
  //height: ${({ scrollable }) => (scrollable ? "720px" : "auto")};
  //overflow-y: ${({ scrollable }) => (scrollable ? "scroll" : "unset")};
  height: 720px;
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding:5px 10px 0px 10px;

  &::-webkit-scrollbar {
    display: none;
  }

  display: flex;
  flex-direction: column;
   gap: 10px;
`;

export const EmptyStateMessage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  text-align: center;
  padding: 0 10px;
`;

export const ScrollButtonWrapper = styled.div`
  position: absolute;
  bottom: -24px; 
  width: 100%;
  text-align: center;
  z-index: 15;
  display: flex;
  justify-content: center;
  gap: 10px;
`;

export const ScrollButton = styled.button`
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: white;  /* Add this for testing */
  border: 1px solid #ccc;
  z-index: 99;
`;


